<template>
  <div
    id="com_mod_yield"
    class="com-mod-section-container"
  >
    <div class="gray-bar-top app clearfix">
      <div class="row">
        <div class="col-md-12">
          <h3 class="app-title">
            Yield
          </h3>
        </div>
        <div class="col-md-12">
          <table>
            <thead>
              <tr>
                <th scope="col" />
                <th
                  class="table-data align-right"
                  scope="col"
                >
                  12-month
                </th>
                <th scope="col" />
              </tr>
              <tr class="gray-bar-bottom">
                <th scope="col" />
                <th
                  class="table-data align-right"
                  scope="col"
                >
                  Distribution Rates
                  <disclosure-superscript
                    class="detail-page"
                    anchor="yield12Month"
                    :statistics="['distRate12M']"
                  />
                </th>
                <th
                  class="table-data align-right"
                  scope="col"
                >
                  30-day SEC Yield
                  <i-ball-modal tag="SECYield" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="gray-bar-bottom">
                <td class="com-mod-table-data align-left">
                  Fund at NAV
                </td>
                <td class="com-mod-table-data align-right strong">
                  {{ $format.rawPercent(getYield.distributionRateNAV) }}
                </td>
                <td class="com-mod-table-data align-right strong">
                  {{ $format.rawPercent(getYield.secYield30DayNet) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-12">
          <span class="sub-info adjust-date">
            As of {{ $format.shortDate(getRecentDate) }} (updated monthly)
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getMostRecentDate } from '../../shared/utils/utils';
export default {
	name: 'YieldModule',
	computed: {
		...mapGetters([
			'getYield'
		]),
		getRecentDate() {
			//gets most recent date from distributionRateDate and secYield30DayNetDate
			const distributionRateDate = this.getYield.distributionRateDate;
			const secYield30DayNetDate = this.getYield.secYield30DayNetDate;
			const date = getMostRecentDate(distributionRateDate, secYield30DayNetDate);

			this.$EventBus.$emit('ExcelData', 'YieldModule', Object.assign({}, this.getYield, {
				distributionRateNAV: this.$format.rawPercent(this.getYield.distributionRateNAV),
				secYield30DayNet: this.$format.rawPercent(this.getYield.secYield30DayNet),
				secYield30DayGross: this.$format.rawPercent(this.getYield.secYield30DayNet),
				asOfDate: this.$format.shortDate(date)
			}));
			return date;
		}

	}
};
</script>

<style lang="less" scoped>
#afis-app {
	#com_mod_yield {
		tr td:not(:first-child) {
			color: #333333;
		}
		thead {
			tr:nth-child(2) {
				th {
					padding: 0px 5px 5px 10px;
				}
			}
		}
		td {
			padding: 5px 5px 5px 0px;
			margin: 1px 0px 1px 0px;
		}
	}
}


</style>

